<template>
    <v-dialog
      v-model="show"
      max-width="490"
    >
      <v-card>
        <v-card-title dark>
          <img class="mr-4" src="img/brand/apio-cygnet.svg" />
          <h5>Welcome to Apio!</h5>
        </v-card-title>

        <v-card-text class="d-flex justify-space-between">
          <v-icon class="mr-6" x-large>mdi-lightbulb-on-outline</v-icon>
          <vue-simple-markdown :source="hints[index]"></vue-simple-markdown>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="newindex"
          >
            Next Hint
          </v-btn>

          <v-btn
            text
            @click="close"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import Vue from 'vue'
import VueSimpleMarkdown from 'vue-simple-markdown'
import 'vue-simple-markdown/dist/vue-simple-markdown.css'
Vue.use(VueSimpleMarkdown)

export default {
  data() {
    return {
      hints: [
        "Any time you need help, you can find ![?](/img/misc/questionmark.png) icon on the top right corner. These tips are also in our documentation.",
        "App upgrades don't like containerised (for example Docker) environment, as soon as the new app running, the old one will quit, bringing down the container with itself. One soultion is to run the container with `tail -f /dev/null` command and start the app in background.",
        "Be careful with infinite loops when using Jump and If steps, always use and test your conditions!",
        "Cron module parses your cron value and explains it in plain English!",
        "Don't use hardcoded credentials in your interfaces, Environment variables can be used nearly everywhere with `=<.variable_name>=` syntax",
        "Generating comma separated list with templates: `{{range $k, $v := .Items}}{{if $k}},{{end}}{{$v}}{{end}}` the trick is that if `$k` part will only add a comma from the second iteration (it's false for `$k=0` )",
        "If you need a static web server serving some files on the same port your app is running, you can use an interface with a HTTP Listen input, set port and path (to / for example) choose folder from the parser dropdown and set the path for your static webroot (with your html files) in the appearing folder field.",
        "Please remember, the app works with data structures and not JSON, we are only using JSON as representation of the data (nearly) everywhere.",
        "Running an App on macOS is difficult, after you downloaded the app the system will complain about signatures. Open System Preferences and go to Security & Privacy's General tab to allow running the app. After this when trying to run the App again, there will be an Open option in the appearing dialog.",
        "Swap a header field's value with the payload before pagination, this way you are not limited to paginate on the payload.",
        "The App has a green LED next to its name on the Build screen when it's running and connected, after modifying the interface codes you can simply click on Upgrade to deploy the changes. The already running app download the new app, run it and then quit when the new app is connected.",
        "To disable a step temporarily, write `0` (zero) into the condition field.",
        "Use cron to start a one-off process, for example `0 0 4 12 11 *` will run only on 12 November at 4am.",
        "We are here to help, you can book a consultation any time, we have years of experience connecting systems.",
        "You can export and import interface declaration code from the editor. Use this to exchange ideas, document your code or safety backup.",
        "You can log in with your Google account. If you are registered beforehand we can migrate over your user, just let us know.",
        "You can run your app as a background process, but if you want to make sure it's running as intended you can also run it in a screen session. A handy trick there is `screen -S Apio` to name the screen session.",
        "You can't run the same app twice, the second instance will trigger the first app's upgrade code and it will quit. You can duplicate the app in the build screen and run it as a new app."
      ],
      index: 0,
      show: true,
    };
  },
  created() {
    let hints = localStorage.getItem('hints');
    if (hints !== null) {
      this.show = false;
    }
  },
  methods: {
    close() {
      localStorage.setItem('hints', false);
      this.show = false;
    },
    newindex() {
      this.index = Math.floor(Math.random() * this.hints.length);
    },
  },
};
</script>
